const state = {
  carts: [],
  totalPrice: 0,
}

const getters = {
  carts: (state) => {
    return state.carts
  },
  totalPrice: (state) => {
    return state.carts.reduce((total, cart) => {
      return total + cart.price * cart.count
    }, 0)
  },
}

const mutations = {
  ADD_CART: (state, cart) => {
    // // 检查购物车中是否已经存在该商品
    // const existingCart = state.carts.find(item => item.id === cart.id)
    // if (!existingCart) {
    //   // 如果不存在，则添加到购物车
    //   state.carts.push(cart)
    // }
    state.carts = [cart]
  }
}

const actions = {
  // 添加购物车
  addCart({ commit }, cart) {
    commit('ADD_CART', cart)

    sessionStorage.setItem('carts', JSON.stringify(cart))
  },
  // 加载购物车
  loadCart({ commit }) {
    const carts = sessionStorage.getItem('carts')
    if (carts) {
      commit('ADD_CART', JSON.parse(carts))
    }
  },
  // 清空购物车
  clearCart({ commit }) {
    commit('ADD_CART', [])
    sessionStorage.removeItem('carts')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
